<template>
  <div>
    <h3>{{$t('message.init_agung') | title}}</h3>

    <b-form v-if="initConfig">
      <b-form-row>
        <b-alert variant="info" :show="['start', 'network set', 'mode set'].includes(initConfig.state)">
          {{$t('message.init_hint_license_first')}}
        </b-alert>
      </b-form-row>
      <b-form-row v-if="initConfig.mode=='cluster'">
        {{$t('message.init_cluster_warning')}}
      </b-form-row>

      <b-form-row v-if="initConfig.state == 'license set'">
        <label class="label label-default col-4 offset-3" for="auto_generate">
          {{$t('message.init_agung_generate') | title}}
        </label>
        <div class="form-group form-check">
          <input type="checkbox" class="form-check-input" v-model="generateInitParams" id="auto_generate"/>
        </div>
      </b-form-row>

      <b-form-row v-if="initConfig.state == 'license set' && !generateInitParams"
        v-for="(param, paramName) in initParams">
        <div class="col-4">
          <span class="label label-default">
            {{$t('message.init_agung_' + paramName) | title}}
          </span>
        </div>
        <div class="col-6">
          <b-form-input v-model="param.value" :type="param.type"
            autocomplete="new-password" @change="validate(paramName)"/>
          <span v-if="param.errorCode" class="error">
            {{$t('message.init_agung_error_' + param.errorCode)}}
          </span>
        </div>
        <div class="col-1" v-if="param.type == 'password' && (paramName == 'password' || paramName == 'vault_password')">
          <svg class='icon icon-eye' @click="param.type='text'"/>
        </div>
        <div class="col-1" v-if="param.type == 'text' && (paramName == 'password' || paramName == 'vault_password')">
          <svg class='icon icon-eye-active' @click="param.type='password'"/>
        </div>
      </b-form-row>

      <div v-if="error" class="form-error">{{error}}</div>

      <b-button type="button" variant="primary" class="padmin-button submit-button" @click="initialize"
        :disabled="initConfig.state !== 'license set' || initInProgress || (!generateInitParams && !initParamsOk)">
        <b-spinner v-if="initInProgress" small type="grow"/>
        {{$t('message.button_initialize') | title}}
      </b-button>
      <b-button v-if="initConfig && initConfig.state == 'db initialized'" type="button"
        class="padmin-button next-button right" :disabled="initInProgress" @click="next">
        {{$t('message.button_next') | title}}
      </b-button>
    </b-form>

    <ConsoleOutput v-if="initInitiated" :result="result" :output="output"/>

    <b-modal ref="init-success-modal" size="lg" ok-only :title="$t('message.init_success')">
      <pre>
        {{initialPasswords}}
      </pre>
      <div id="passwords-warning">{{$t("message.init_agung_passwords_warning")}}</div>
    </b-modal>
  </div>
</template>

<script>
import ConsoleOutput from "./ConsoleOutput"
import { get, post } from "../http"
import { EventBus } from "../event-bus.js"

export default {
  name: "InitAgung",

  components: {
    ConsoleOutput
  },

  data() {
    return {
      generateInitParams: true,
      initParams: {
        username: {value: "", type: "text"},
        password: {value: "", type: "password"},
        first_name: {value:"", type: "text"},
        last_name: {value: "", type: "text"},
        email: {value: "", type: "email"},
        vault_username: {value: "", type: "text"},
        vault_password: {value:"", type: "password"},
      },
      result: null,
      output: "",
      initialPasswords: "",
      initConfig: null,
      initInProgress: false,
      initInitiated: false,
      passwordInputType: 'password',
    };
  },

  mounted() {
    this.loadInitConfig()
  },

  computed: {
    initParamsOk() {
      return !this.generateInitParams && Object.values(this.initParams).every(par => par.errorCode == undefined || par.errorCode.length == 0);
    }
  },

  methods: {
    loadInitConfig() {
      get('/init').then(
        resp => {
          this.initConfig = resp.data;
        },
        err => {
          console.log("err", err)
        }
      )
    },

    validate(paramName) {
      let param = this.initParams[paramName];
      let errorCode = '';
      if (param.value.length) {
        if (paramName == 'vault_password') {
          if (param.value.length < 16) {
            errorCode = 'min_length_16';
          }
        }
        if (paramName == 'email') {
          const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (!re.test(param.value)) {
            errorCode = 'invalid_email';
          }
        }
      }
      this.$set(param, 'errorCode', errorCode);
    },

    initialize() {
      if (!this.generateInitParams && !this.initParamsOk) {
        return
      }
      const formData = new FormData();

      if (!this.generateInitParams) {
        for (let field in this.initParams) {
          if (this.initParams[field].value) {
            formData.append(field, this.initParams[field].value)
          }
        }
      }

      this.initInitiated = true
      this.initInProgress = true
      this.result = null
      this.output = ""

      post("/init/agung", formData, {"content-type": "multipart/form-data"}).then(
        resp => {
          this.initInProgress = false
          this.output = resp.data.output
          this.result = resp.data.result
          if (resp.data.result === true) {
            this.initialPasswords = resp.data.init_output
            this.loadInitConfig()
            this.$refs['init-success-modal'].show()
          }
          if (resp.data.error) {
            this.error = this.$t('message.error_' + resp.data.error)
          }
        },
        err => {
          this.result = false
          this.initInProgress = false
          console.log("err", err)
        }
      )
    },
    next() {
      EventBus.$emit('progress init')
    }
  }
}
</script>

<style scoped>
#passwords-warning {
  color: white;
  background-color: red;
  font-size: 18px;
}
.error {
  color: red;
  margin-left: 5px;
}
</style>
